var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fillRule":"nonzero","points":"0 1.2121947 1.55284138 0 9 9.43171841 1.47856211 17 0.0742792694 15.6202396 6.37238103 9.28256974"}));
}

CaretRight.defaultProps = {"viewBox":"0 0 9 17","version":"1.1"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
